import { render, staticRenderFns } from "./InterCommDiscRates.vue?vue&type=template&id=1f23150a&"
import script from "./InterCommDiscRates.vue?vue&type=script&lang=js&"
export * from "./InterCommDiscRates.vue?vue&type=script&lang=js&"
import style0 from "./InterCommDiscRates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InterCommDiscRates.vue"
export default component.exports